export { default } from "./StudentsSettingsPage";
